// 解决方案详情页
<template>
  <div>
    <!--<common-header />-->
    <div class="solution-center">
      <div v-if="$i18n.locale === 'en_US'">
        {{ solution.enTitle }}
      </div>
      <div v-else>
        {{ solution.title }}
      </div>
      <div>
        <div>
          {{ $t("information.releaseTime") }}：{{ solution.releaseTime }}
        </div>
        <div>{{ $t("information.readNum") }}：{{ solution.readNumber }}</div>
      </div>
      <div class="htmlContent">
        <div v-if="$i18n.locale === 'en_US'" v-html="solution.enContent" />
        <div v-else v-html="solution.content" />
      </div>
    </div>
  </div>
</template>

<script>
// import CommonHeader from "@/components/CommonHeader";
export default {
  name: "JdNewsDetail",
  components: {
    // CommonHeader
  },
  data() {
    return {
      // 新闻ID
      solutionId: this.$route.query.solutionId,
      // 新闻实体
      solution: {},
    };
  },
  created() {
    this.getSolutionById();
  },
  methods: {
    getSolutionById() {
      let url = `/item/solution/getSolutionById?id=${this.solutionId}`;
      this.$doGet(url)
        .then((res) => {
          if (res.code == 200) {
            this.solution = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
/**:消息内容 */
.solution-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 18px auto;
}
.solution-center > div:nth-child(1) {
  height: 24px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 24px;
  margin-bottom: 8px;
}
.solution-center > div:nth-child(2) {
  display: flex;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 24px;
  margin-bottom: 18px;
}
.solution-center > div:nth-child(2) > div:nth-child(1) {
  margin-right: 32px;
}
.htmlContent {
  margin-bottom: 100px;
  padding: 0 110px;
}
</style>
